import type { ShopDto, UpdateOneShopRefundDto } from "../generated/schema";
import useInvalidateShop from "./use-invalidate-shop";
import { useApiMutation } from "./use-api-mutation";

export default function useUpdateShopRefund(shop: ShopDto) {
  const invalidateShop = useInvalidateShop(shop.id);

  return useApiMutation("patch", "/shops/{shopId}/refunds", {
    invalidate: invalidateShop,
    mapVariables: (data: UpdateOneShopRefundDto) => ({
      params: { path: { shopId: shop.id } },
      body: data,
    }),
  });
}
